import { useQuery } from '@apollo/client';
import { MobileOpCode, Query } from 'graphql/generated/graphqlTypes';
import { GET_ACCESS_EVENTS_FOR_TENANT } from 'graphql/v2/queries';
import { BaseHookProps } from 'hooks/shared/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useEffect } from 'react';

interface Props extends BaseHookProps {
  visitorId: string;
}

const useVisitorDetailsAccessEvents = ({ handleFetchError, visitorId }: Props) => {
  const { translation } = useTranslation();

  const {
    loading: accessEventsLoading,
    error: accessEventsError,
    data: accessEventsData
  } = useQuery<Pick<Query, 'getAccessEventsForTenant'>>(GET_ACCESS_EVENTS_FOR_TENANT, {
    variables: {
      filter: {
        visitorIds: [visitorId],
        actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted]
      }
    }
  });

  useEffect(() => {
    if (accessEventsError) {
      handleFetchError(translation.access_events_error_fetching);
      console.error(accessEventsError);
    }
  }, [accessEventsError]);

  return {
    visitorDetailsAccessEvents: accessEventsData?.getAccessEventsForTenant.items,
    loadingGetVisitorDetailsAccessEvents: accessEventsLoading
  };
};

export default useVisitorDetailsAccessEvents;
